import { Toast } from "primereact/toast";
import { useEffect, useRef } from "react";
import "primereact/resources/themes/saga-blue/theme.css"; // Tema PrimeReact
import "primereact/resources/primereact.min.css"; // Estilos do PrimeReact
import "primeicons/primeicons.css"; // Ícones do PrimeReact
import LandingHeader from "./components/LandingHeader/LandingHeader";
import LandingDropdown from "./components/LandingDropdown/LandingDropdown";
import LandingNav from "./components/LandingNav/LandingNav";
import "./landing.css";
import LandingComoFunciona from "./components/LandingComoFunciona/LandingComoFunciona";
import LandingChoosePath from "./components/LandingChoosePath/LandingChoosePath";
import LandingVideoSection from "./components/LandingVideoSection/LandingVideoSection";
import LandingAboutSectionOne from "./components/LandingAboutSectionOne/LandingAboutSectionOne";
import LandingStoreSection from "./components/LandingStoreSection/LandingStoreSection";
import LandingFooter from "./components/LandingFooter/LandingFooter";
import LandingExclusiveSection from "./components/LandingExclusiveSection/LandingExclusiveSection";
import LandingEcosystemCycle from "./components/LandingEcosystemCycle/LandingEcosystemCycle";
import LandingPlans from "./components/LandingPlans/LandingPlans";
import LandingWorkWithUs from "./components/LandingWorkWithUs/LandingWorkWithUs";
import LandingFaqComponent from "./components/LandingFaq/LandingFaqComponent";
import LandingTransitionBar from "./components/LandingTransitionBar/LandingTransitionBar";
import localeText from "../../locale";
import { Link, useLocation } from "react-router-dom";
import SEO from "../../components/SEO/SEO";
import LandingCopyright from "./components/LandingCopyright/LandingCopyright";
import N8nChatbot from "../../components/N8nChatbot/N8nChatbot";

function LandingPage() {
  const toast = useRef(null);
  const location = useLocation();

  const scrollToSection = (elementId) => {
    const element = document.getElementById(elementId);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  useEffect(() => {
    if (location.hash) {
      scrollToSection(location.hash.replace("#", ""));
    }
  }, [location.hash]);

  return (
    <div>
      <SEO title="Extraconomy" description={localeText("seoDescription")} />
      <Toast ref={toast} />

      {/* Navbar */}
      <div
        style={{ backgroundColor: "#3E8B5C", margin: "0" }}
        className="flex align-items-center justify-content-between nav-responsive sticky top-0 z-3"
      >
        <LandingNav scrollToSection={scrollToSection} />
        <Link
          className="hidden xl:flex font-bold gap-3 xl:px-6 px-4 border-noround border-none p-button-no-outline p-button-cart-hover align-items-center text-white"
          style={{ backgroundColor: "#2A2560", fontSize: "16px", height: "100%" }}
          to="/shop"
        >
          <i style={{ fontSize: "24px" }} className="pi pi-shopping-cart"></i>{" "}
          <span className="hidden xl:inline font-system">{localeText("toTheStore")}</span>
        </Link>
        <div className="xl:hidden flex h-full">
          <LandingDropdown scrollToSection={scrollToSection} />
        </div>
      </div>

      <div className="bg-white content-grid landing">
        {/* Cabeçalho */}
        <LandingHeader scrollToSection={scrollToSection} />

        {/* Como funciona */}
        <LandingComoFunciona />

        {/* Vídeo institucional */}
        <LandingVideoSection />

        {/* Escolha como participar */}
        <LandingChoosePath />

        <LandingTransitionBar
          title={localeText("lp2Bar1Title")}
          text={localeText("lp2Bar1Text")}
          anchor="#negocio"
        />

        {/* Sobre / secção 1 / secção 2*/}
        <LandingAboutSectionOne />

        <LandingTransitionBar
          title={localeText("lp2Bar2Title")}
          text={localeText("lp2Bar2Text")}
          anchor="#store-conveniado"
        />

        <LandingStoreSection />

        <LandingTransitionBar
          title={localeText("lp2Bar2Title")}
          text={localeText("lp2Bar2Text")}
          anchor="#resources"
        />

        {/* Recursos */}
        <LandingExclusiveSection />

        <LandingTransitionBar
          title={localeText("lp2Bar3Title")}
          text={localeText("lp2Bar3Text")}
          anchor="#ecossistema"
        />

        {/* Ecossistema */}
        <LandingEcosystemCycle />

        <LandingTransitionBar
          title={localeText("lp2Bar4Title")}
          text={localeText("lp2Bar4Text")}
          anchor="#plans"
        />

        {/* Planos */}
        <LandingPlans />

        <LandingTransitionBar
          title={localeText("lp2Bar5Title")}
          text={localeText("lp2Bar5Text")}
          anchor="#promotor"
        />

        {/* Trabalhe conosco */}
        <LandingWorkWithUs />

        {/* FAQ */}
        <LandingFaqComponent />

        {/* Footer */}
        <LandingFooter />
        <LandingCopyright />
        <section
          className="py-4 full-width"
          style={{ backgroundColor: "#FFFFFF", color: "#5B6472", borderTop: "1px solid #DDE6E0" }}
        >
          <div className="flex flex-wrap align-items-center justify-content-between gap-3">
            <div
              className="flex flex-wrap align-items-center gap-2 text-xs"
              style={{ color: "#5B6472" }}
            >
              <span>EXTRACONOMY GLOBAL srl · Via Nomentana, 1018 - 00137 Roma (IT)</span>
              <span className="hidden md:inline">|</span>
              <span>P. Iva e C.F. 16948681008 | REA 1686351</span>
            </div>
            <Link to="/privacy" className="text-xs" style={{ color: "#5B6472" }}>
              Privacy Policy
            </Link>
          </div>
        </section>
      </div>

      {/* Chatbot */}
      <N8nChatbot isConfimeaCardVisible={false} />
    </div>
  );
}

export default LandingPage;
